import preloaderView from './../views/preloader';
import introView from './../views/intro';
import instructionsView from './../views/instructions';
import startView from './../views/start';
import gameView from './../views/game';
import interstitialView from './../views/interstitial';
import gameOverView from './../views/game-over';
import leaderboardView from './../views/leaderboard';
import endView from './../views/end';
import shimmyView from './../views/shimmy';


const router = {
  currentView: null,
  views: [
    {
      path: 'preloader',
      view: preloaderView,
    },
    {
      path: 'intro',
      view: introView,
    },
    {
      path: 'start',
      view: startView,
    },
    {
      path: 'instructions',
      view: instructionsView,
      overlay: true,
    },
    {
      path: 'game',
      view: gameView,
    },
    {
      path: 'interstitial-1',
      view: interstitialView,
    },
    {
      path: 'interstitial-2',
      view: interstitialView,
    },
    {
      path: 'interstitial-3',
      view: interstitialView,
    },
    {
      path: 'game-over',
      view: gameOverView,
    },
    {
      path: 'end',
      view: endView,
    },
    {
      path: 'shimmy',
      view: shimmyView,
    },
    {
      path: 'leaderboard',
      view: leaderboardView,
    },
  ],


  /**
   * Displays a view
   * @param {String} path - The path of the view to display
   * @param {Object} params - Params to pass to the view
   */
  navigate(path, params) {
    let newView;
    let isOverlay;

    for (let i = 0; i < this.views.length; i++) {
      if (this.views[i].path === path) {
        newView = Object.assign({}, this.views[i].view);
        isOverlay = this.views[i].overlay;
      }
    }

    if (!isOverlay || (params && params.standalone)) {
      if (this.currentView) {
        this.currentView.destroy();
        this.currentView = null;
      }

      newView.init(params);
      this.currentView = newView;
    } else {
      newView.init(params);
    }
  },
};

export default router;



/** WEBPACK FOOTER **
 ** ./assets/js/src/router/router.js
 **/